import { AppState } from './app/app.state';
import { AuthState } from './auth/auth.state';
import { CommentState } from './comment-state/comment.state';
import { ComponentRegistryState } from './component-registry-state/component-registry.state';
import { CoreCollectionState } from './core-collection/core-collection.state';
import { CoreCounterState } from './core-counters/core-counters.state';
import { CoreQueryState } from './core-query/core-query.state';
import { CoreSpaceState } from './core-space/core-space.state';
import { DashboardState } from './dashboard-state/dashboard.state';
import { DataStoreState } from './data-store-state/data-store.state';
import { DelegationState } from './delegation';
import { EntityState } from './entity-data-state/entity.state';
import { EntryState } from './entry-data-state/entry.state';
import { CoreFileLinkState } from './file-state/file-link.state';
import { GenericViewsState } from './generic-views/generic-views.state';
import { LoadingState } from './loading/loading.state';
import { ModuleState } from './modules-data-state/module.state';
import { NavigationState } from './navigation/navigation.state';
import { NotificationState } from './notification/notification.state';
import { PermissionsState } from './permissions/permissions.state';
import { ReactionState } from './reaction/reaction.state';
import { RelationState } from './relation-data-state/relation.state';
import { ReportsState } from './reports-state/reports.state';
import { STQueryCoreState } from './st-query-core-state/st-query-core.state';
import { CoreSystemButtonsState } from './system-button-state/core-system-button.state';
import { TimelineState } from './timeline/timeline.state';
import { LanguageState } from './translation/language.state';
import { EntityUIState } from './ui-state';
import { UserPreferencesState } from './user-preferences/user-preferences.state';
import { UserState } from './user/user.state';
import { ViewState } from './view-data-state/view.state';

export const CORE_STATES = [
  AppState,
  AuthState,
  NavigationState,
  UserState,
  LanguageState,
  PermissionsState,
  UserPreferencesState,
  LoadingState,
  ComponentRegistryState,
  EntityState,
  EntryState,
  ViewState,
  ModuleState,
  RelationState,
  GenericViewsState,
  DashboardState,
  ReportsState,
  CoreCollectionState,
  CoreQueryState,
  STQueryCoreState,
  TimelineState,
  NotificationState,
  CommentState,
  CoreCounterState,
  CoreSystemButtonsState,
  DataStoreState,
  CoreFileLinkState,
  CoreSpaceState,
  // UI States
  EntityUIState,
  ReactionState,
  DelegationState,
];

export * from './app/app.actions';
export * from './app/app.state';
export * from './auth/auth.actions';
export * from './auth/auth.state';
export * from './comment-state/comment.actions';
export * from './comment-state/comment.state';
export * from './component-registry-state/component-registry.action';
export * from './component-registry-state/component-registry.state';
export * from './core-collection/core-collection.actions';
export * from './core-collection/core-collection.state';
export * from './core-counters/core-counters.actions';
export * from './core-counters/core-counters.state';
export * from './core-query/core-query.action';
export * from './core-query/core-query.state';
export * from './core-space/core-space.actions';
export * from './core-space/core-space.state';
export * from './dashboard-state/dashboard.action';
export * from './dashboard-state/dashboard.state';
export * from './entity-data-state/entity.action';
export * from './entity-data-state/entity.state';
export * from './entry-data-state/entry.action';
export * from './entry-data-state/entry.state';
export * from './file-state/file-link.action';
export * from './file-state/file-link.state';
export * from './generic-views/generic-views.actions';
export * from './generic-views/generic-views.state';
export * from './loading/loading.actions';
export * from './loading/loading.state';
export * from './modules-data-state/module.action';
export * from './modules-data-state/module.state';
export * from './navigation/navigation.actions';
export * from './navigation/navigation.state';
export * from './notification/notification.action';
export * from './notification/notification.state';
export * from './permissions/permissions.actions';
export * from './permissions/permissions.state';
export * from './reaction/reaction.action';
export * from './reaction/reaction.state';
export * from './relation-data-state/relation.action';
export * from './relation-data-state/relation.state';
export * from './reports-state/reports.actions';
export * from './reports-state/reports.state';
export * from './st-query-core-state/st-query-core.action';
export * from './st-query-core-state/st-query-core.state';
export * from './system-button-state/core-system-button.action';
export * from './system-button-state/core-system-button.state';
export * from './timeline/timeline.action';
export * from './timeline/timeline.state';
export * from './translation/language.actions';
export * from './translation/language.state';
// UI States
export * from './data-store-state/data-store.action';
export * from './data-store-state/data-store.state';
export * from './delegation';
export * from './ui-state';
export * from './user-preferences/user-preferences.actions';
export * from './user-preferences/user-preferences.state';
export * from './user/user.actions';
export * from './user/user.state';
export * from './view-data-state/view.action';
export * from './view-data-state/view.state';
